import { OrderSide, PairSymbol } from "@cede/types";
import { getTokensFromPairSymbol } from "./getTokensFromPairSymbol";

export const getFromAndToTokenSymbolsFromPairSymbol = (pairSymbol: PairSymbol, orderSide: OrderSide) => {
  const [base, quote] = getTokensFromPairSymbol(pairSymbol);
  return {
    fromTokenSymbol: orderSide === "sell" ? base : quote,
    toTokenSymbol: orderSide === "sell" ? quote : base,
  };
};
